export default __webpack_public_path__ + "static/0282-f68262ffd3842fac8b45f6df13f4411e.png";